import React from 'react';

import * as OrganizationActions from 'actions/OrganizationActions';
import {NavStoreProject} from 'constants/SourceConstants';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import ProjectsTable from './ProjectsTable';

interface Props {
  isCurrentUserMember: boolean;
  teamId: string;
  teamProjects?: Array<NavStoreProject>;
}

class TeamProjectsTab extends React.Component<Props> {
  _handleUpdateProjectSettings = (): void => {
    // Refetch the projects to reflect any changes.
    OrganizationActions.fetchProjects(this.props.teamId);
  };

  render(): JSX.Element {
    if (this.props.teamProjects == null) {
      return <CenteredHorizontalThrobber />;
    }

    if (this.props.teamProjects.length === 0) {
      return this.props.isCurrentUserMember ? (
        <div>This team has no projects yet.</div>
      ) : (
        <div>
          No projects yet. Projects shared with the team that you have permission to view will show up here.
        </div>
      );
    }

    return (
      <ProjectsTable
        onUpdateProjectSettings={this._handleUpdateProjectSettings}
        projects={this.props.teamProjects}
        shouldShowOwnerColumn={false}
      />
    );
  }
}

export default TeamProjectsTab;
